module.exports = __webpack_public_path__ + "img/beneficios-05.0711aa9e.png";